// extracted by mini-css-extract-plugin
export var controls = "ArticleList-module--controls--rkR+d";
export var slider = "ArticleList-module--slider--bvX9g";
export var title = "ArticleList-module--title--8PPMJ";
export var wrapper = "ArticleList-module--wrapper--e46sG";